import { customFetch } from '@skytech/auth'
import { config } from '@skytech/config'
import { EMAIL_PATTERN } from '@skytech/utils'

import { API_ROUTE_AUTHENTICATE, API_ROUTE_MANAGER_TOKEN } from './apiRoutes'

const authFetchConfig = {
  credentials: 'include' as const,
  environment: config.AUTH_API_URL,
}

const authResources = {
  getSettings: ({ phoneNumber, phoneCountryId }: { phoneCountryId: number; phoneNumber: string }) =>
    customFetch<{
      isAccessCodeRequired: boolean
      isPasswordRequired: boolean
      hasMsalLogin: boolean
      phoneCountryId: number
    }>({
      path: `dealer/authenticate/settings/${phoneCountryId}/${phoneNumber}`,
      ...authFetchConfig,
    }),
  getManagerToken: (customerId: number) =>
    customFetch<{ token: string }>({
      path: API_ROUTE_MANAGER_TOKEN.replace(':customerId', String(customerId)),
      ...authFetchConfig,
    }),

  // Mutations
  logIn: (args: {
    phoneCountryId: number
    userName?: string
    password?: string
    accessCode?: string
    sessionId?: string
  }) => {
    const { phoneCountryId, ...payload } = args
    return customFetch<{
      token: string
    }>({
      path: API_ROUTE_AUTHENTICATE,
      method: 'POST',
      data: { ...payload, countryId: phoneCountryId },
      ...authFetchConfig,
    })
  },
  generatePassword: (phoneNumber: string) =>
    customFetch<null>({
      path: `dealer/${phoneNumber}/key/generate`,
      method: 'POST',
      data: {
        sendMail: phoneNumber.match(EMAIL_PATTERN),
      },
    }),
  deleteRefreshToken: () =>
    customFetch<{ token: string }>({
      method: 'DELETE',
      path: 'dealer/token',
      ...authFetchConfig,
    }),
}

export default authResources
